export default {
  getRateSchedule: (state) => state.rateSchedule,
};
